<template>
    <div id="gps-select">
        <a-divider class="line" >地址选择</a-divider>
        <div class="btn-group">
            <a-button 
                v-for="(item,index) in selectArr"
                :key="index"
                :type="index===activeIndex? 'primary':''"
                @click="selectChange(index)"
            >
                {{item}} 
            </a-button>
        </div>
        <div class="content">
            <a-button
                v-if="prevAllProvince"
                class="go-back-btn" 
                icon="rollback"
                @click="goBack"
                size="small"
            >
                返回上一级
            </a-button>
            <div class="all-city" v-if="allProvince.length">
                <div 
                    v-for="(item,index) in allProvince"
                    :key="index"
                    class="city-item"
                >
                    <span 
                        class="initial" 
                        v-if="allProvince[index-1]"
                        :class="item.initial !== allProvince[index-1].initial ? '':'transparent'"
                    >
                        {{item.initial !== allProvince[index-1].initial ? item.initial:''}}
                    </span>
                    <span class="initial" v-else>
                        {{item.initial}}
                    </span>
                    <span class="name" @click="selectAllCityName(item)">
                        <span>
                            {{item.name}}
                            <a-icon class="icon" v-if="!item.value && !item.children" type="right" />
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
import Bus from "@/utils/EventBus.js"
import Cookies from 'js-cookie';
export default {
    name:"SelectCity",
    data () {
        return {
            prevAllProvince: null, // 之前的信息
            allProvince: [],
            selectArr: ['全国','区域','热门城市','会员城市'],
            activeIndex: 0,
            saveArea: null
        };
    },
    created(){
        this.getAllProvince();
    },
    components: {

    },
    computed: {

    },
    methods: {
        // 地址选择类型切换
        selectChange(index){
            this.activeIndex = index;
            this.saveArea = null;
            switch (index) {
                case 0:
                    this.getAllProvince();
                    break
                case 1:
                    this.saveArea = true;
                    this.getRegionCity()
                    break
                case 2:
                    this.getHotorVipCity("hot")
                    break
                case 3:
                    this.getHotorVipCity("vip");

            }
        },
        // 全国城市选择
        getAllProvince(){
            let url = UrlApi.allProvince;
            this.$http.get(url).then((res)=>{
                this.allProvince = res.data.data;
            })
        },
        // 区域城市选择
        getRegionCity(){
            let url = UrlApi.regionCity;
            this.$http.get(url).then((res)=>{
                this.allProvince = res.data.data;
            })
        },
        getHotorVipCity(cityType){
            let url = UrlApi.hotCity;
            let params = {
                cityType: cityType
            }
            this.$http.get(url,{
                params:params
            }).then((res)=>{
                this.allProvince = res.data.data;
            })
        },
        // 全国-选择城市
        selectAllCityName(city){
            if(city.value){
                let gpsState = {
                    area: this.saveArea || city.province,
                    city: city.name,
                    cityCode:city.value
                }
                if(!gpsState.area){
                    gpsState.area = gpsState.city;
                }
                this.$store.commit("updateGpsState",gpsState);
                Cookies.set("BSG-gpsState",gpsState);
                let saveRouter = this.$store.getters.getSaveRouter;
                if(!saveRouter){
                    Bus.$emit("goBackToHome");
                    return
                }
                this.$router.push({ name: saveRouter.name,params: saveRouter.params,query:saveRouter.query});
                return
            }
            // 选择区域 保存
            if(this.saveArea) {
                this.saveArea = city.name;
            }
            let url = UrlApi.provinceCity;
            let params = {
                province: city.name
            }
            this.$http.get(url,{
                params:params
            }).then((res)=>{
                this.prevAllProvince = this.allProvince;
                this.allProvince = res.data.data;
            })
        },
        goBack(){
            this.allProvince = this.prevAllProvince;
            this.prevAllProvince = null;
        }
    }
}

</script>
<style lang="less" scoped>
    #gps-select {
        background-color: #ffffff;
        width: calc(100% - 60px);
        margin: 0 auto;
        padding: 0 30px;
        margin-top: 30px;
        margin-bottom: 30px;
        overflow: hidden;
        min-height: calc(100vh - 205px);
        .line {
            font-size: 22px;
            margin-top: 30px;
            &::before{
                border-top: 1px solid #2F639A;
                }
            &::after{
                border-top: 1px solid #2F639A;
            }
        }
        .btn-group {
            display: flex;
            justify-content: center;
            button {
                margin-right: 20px;
            }
        }
        .content {
            padding: 30px 0;
            .all-city {
                border:1px solid #DDDDDD;
            }
            .go-back-btn {
                color: #1890ff;
                border-color: #1890ff;
                margin-bottom: 30px;
            }
            .city-item {
                height: 50px;
                line-height: 50px;
                color: #101d37;
                font-weight: bolder;
                font-size: 18px;
                display: flex;
                justify-content: flex-start;
                &:first-child {
                    .initial {
                        border-top:none;
                    }
                }
                .initial {
                    width: 50px;
                    height: 100%;
                    text-align: center;
                    background-color: #F8F8F9;
                    color: #AFB3BB;
                    font-size: 22px;
                    border-top:1px solid #DDDDDD;
                    &.transparent {
                        border-top:1px solid #F8F8F9;
                    }
                }
                .name {
                    width: calc(100% - 50px);
                    height: 51px;
                    text-indent: 20px;
                    border-bottom:1px solid #DDDDDD;
                    cursor: pointer;
                    .icon {
                        margin-left: 20px;
                        color: #AFB3BB;
                        font-size: 16px;
                    }
                    &:hover {
                        color: #1890FF;
                    }
                }
            }
        }
    }
</style>